module.exports = __webpack_public_path__ + "static/media/chatbox.ecb2a175.jpg";